import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetBuildingsCityReport_cityTaskMetrics_cityMetrics as CityMetricsGenerated,
  GetBuildingsCityReport as GetBuildingsCityReportGenerated,
  GetBuildingsCityReportVariables as GetBuildingsCityReportVariablesGenerated,
} from "core/queries/__generated__/GetBuildingsCityReport";

export interface CityMetricsData extends CityMetricsGenerated {}
export interface GetBuildingsCityReportResponse
  extends GetBuildingsCityReportGenerated {}
export interface GetBuildingsCityReportVariables
  extends GetBuildingsCityReportVariablesGenerated {}

const getBuildingsCityReport = gql`
  query GetBuildingsCityReport($filter: TaskMetricsFilterInput!) {
    cityTaskMetrics {
      cityMetrics(filters: $filter) {
        formattedValue
        label
        tooltip
      }
    }
  }
`;

export interface UseGetBuildingsCityReportOptions {
  skip: boolean;
  variables: GetBuildingsCityReportVariables;
}

export const useGetBuildingsCityReportQuery = ({
  skip = false,
  variables,
}: UseGetBuildingsCityReportOptions) =>
  useQuery<GetBuildingsCityReportResponse, GetBuildingsCityReportVariables>(
    getBuildingsCityReport,
    {
      skip,
      variables,
    },
  );
